import { useState } from 'react';

function americanToDecimal(american) {
	const a = parseFloat(american);
	if (isNaN(a) || a === 0) return NaN;
	if (a > -100 && a < 100) return NaN;
	if (a > 0) return a / 100 + 1;
	return 100 / Math.abs(a) + 1;
}

function fractionalToDecimal(fractional) {
	const parts = fractional.split('/');
	if (parts.length !== 2) return NaN;
	const num = parseFloat(parts[0]);
	const den = parseFloat(parts[1]);
	if (!den || isNaN(num) || isNaN(den)) return NaN;
	return num / den + 1;
}

export const ImpliedProbabilityCalculator = () => {
	const [odds, setOdds] = useState('');
	const [format, setFormat] = useState('american');

	let decimal = NaN;
	if (format === 'american') {
		decimal = americanToDecimal(odds);
	} else if (format === 'decimal') {
		decimal = parseFloat(odds);
	} else if (format === 'fractional') {
		decimal = fractionalToDecimal(odds);
	}

	const hasResults = !isNaN(decimal) && decimal > 1;

	let results = null;
	if (hasResults) {
		const impliedProb = (1 / decimal) * 100;
		results = {
			impliedProb,
			decimal,
		};
	}

	const handleReset = () => {
		setOdds('');
	};

	const placeholders = {
		american: '-110 or +150',
		decimal: '2.50',
		fractional: '3/2',
	};

	return (
		<div>
			<div className="calc-section">
				<h3 className="calc-section-title">Odds Format</h3>
				<div className="calc-method-select">
					{['american', 'decimal', 'fractional'].map(f => (
						<button
							key={f}
							className={`calc-method-btn ${format === f ? 'active' : ''}`}
							onClick={() => { setFormat(f); setOdds(''); }}
						>
							{f.charAt(0).toUpperCase() + f.slice(1)}
						</button>
					))}
				</div>
			</div>

			<div className="calc-section">
				<div className="calc-input-group" style={{ maxWidth: '300px' }}>
					<label className="calc-label">Enter Odds</label>
					<input
						className="calc-input"
						type="text"
						placeholder={placeholders[format]}
						value={odds}
						onChange={(e) => setOdds(e.target.value)}
					/>
				</div>
			</div>

			{results && (
				<div className="calc-results">
					<h4 className="calc-results-title">Implied Probability Results</h4>
					<div className="calc-result-row">
						<span className="calc-result-label">Implied Probability</span>
						<span className="calc-result-value highlight">{results.impliedProb.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Breakeven Win Rate</span>
						<span className="calc-result-value">{results.impliedProb.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Decimal Odds</span>
						<span className="calc-result-value">{results.decimal.toFixed(4)}</span>
					</div>
				</div>
			)}

			<button className="calc-reset-btn" onClick={handleReset}>Reset</button>
		</div>
	);
};
